import { render, staticRenderFns } from "./ShortCodeSetModal.vue?vue&type=template&id=b94be45c&scoped=true&"
import script from "./ShortCodeSetModal.vue?vue&type=script&lang=ts&"
export * from "./ShortCodeSetModal.vue?vue&type=script&lang=ts&"
import style0 from "./ShortCodeSetModal.vue?vue&type=style&index=0&id=b94be45c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94be45c",
  null
  
)

export default component.exports